import { Truck } from "lucide-react";
import { format, parseISO } from "date-fns";

const money = (v) => `$${(Number(v) || 0).toFixed(2)}`;

// Read-only breakdown for invoices that bill several deliveries at once.
export const DeliveriesSummary = ({ deliveries, items }) => (
  <div data-testid="public-invoice-deliveries" className="space-y-3">
    <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-brand-charcoal/55">
      {deliveries.length} deliveries on this invoice
    </p>
    {deliveries.map((d, idx) => {
      const lines = items.filter((it) => it.delivery_index === idx);
      const where = [d.address, d.address_line2, d.city, d.state, d.zip_code].filter(Boolean).join(", ");
      return (
        <div key={idx} data-testid={`public-invoice-drop-${idx}`} className="rounded-2xl bg-brand-cream/30 border border-black/5 p-4">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="inline-flex items-center gap-2 font-display font-black text-[15px] text-brand-charcoal">
                <Truck className="h-4 w-4 text-brand-teal" /> {d.label || `Delivery ${idx + 1}`}
              </p>
              <p className="mt-0.5 text-[12px] text-brand-charcoal/65">
                {[d.event_date ? format(parseISO(d.event_date), "EEE, MMM d, yyyy") : null, d.event_time].filter(Boolean).join(" · ") || "Date TBD"}
                {where && ` · ${where}`}
              </p>
            </div>
            <p className="text-[12px] text-brand-charcoal/60 shrink-0 tabular-nums">Delivery {money(d.delivery_fee)}</p>
          </div>
          <ul className="mt-3 divide-y divide-black/5">
            {lines.map((ln, i) => (
              <li key={`${ln.package_id}-${i}`} className="py-2 flex items-baseline justify-between gap-3 text-[13px]">
                <span className="min-w-0 text-brand-charcoal">
                  <b>×{ln.quantity}</b> {ln.name || ln.package_id}
                </span>
                <span className="tabular-nums font-bold shrink-0">{money(ln.unit_price * ln.quantity)}</span>
              </li>
            ))}
          </ul>
        </div>
      );
    })}
  </div>
);

export default DeliveriesSummary;
